import { List, Map, Record } from "immutable";

export const QUIZZES_ONLY_SPEC_TYPE: "quizzes" = "quizzes";

type ModuleId = string;

type QuizzesSpecQuizType = Map<"moduleIds", List<ModuleId>>;

export type QuizzesOnlySpecType = {
  quizzes: Map<string, QuizzesSpecQuizType>;
  courseId?: never;
};

type QuizzesOnlySpecJS = {
  quizzes: {
    [quizId: string]: {
      moduleIds: string[];
    };
  };
  courseId?: never;
};

const defaultQuizzesOnlySpec: QuizzesOnlySpecType = {
  quizzes: Map()
};

export default class QuizzesOnlySpec extends Record(defaultQuizzesOnlySpec) {}

export function fromJS(values: QuizzesOnlySpecJS): QuizzesOnlySpec {
  const { quizzes: quizzesJS } = values;

  const quizzes = Map<string, QuizzesSpecQuizType>().withMutations(
    mutableQuizzes => {
      return Object.keys(quizzesJS).reduce(
        (acc, quizId) =>
          acc.set(
            quizId,
            Map<"moduleIds", List<ModuleId>>({
              moduleIds: List<ModuleId>((quizzesJS as any)[quizId].moduleIds)
            })
          ),
        mutableQuizzes
      );
    }
  );

  return new QuizzesOnlySpec({
    quizzes
  });
}
